module.exports = __webpack_public_path__ + "img/pef_investment_overview_icon03.53400004.svg";